<div class="govuk-grid-row">
  <div class="govuk-grid-column-two-thirds js-enabled">

    <ng-container *ngIf="result; else noResult">

      <h1 class="govuk-heading-l">{{result.name}}</h1>

      <section tabindex="0" #description aria-label="Advice Description">
        <div class="govuk-heading-s">{{result.heading}}</div>
      </section>

      <div class="noprint">
        <section *ngIf="showExitBtn" class="grey-box">
          <div>
            <h2>Reading this page safely</h2>
            <p>If you're worried someone might see you have visited this site,
              please visit our <a href="/safety">safety page</a> for information
              on how to cover your tracks online.
            </p>

            <p>To leave this page quickly you can:</p>
            <ul>
              <li>click one of the exit buttons</li>
              <li>press the shift key three times</li>
            </ul>
          </div>
          <aa-exit-button></aa-exit-button>
        </section>

        <ol class="toc govuk-list  govuk-list--number govuk-list--spaced">
          <li *ngFor="let para of result.paragraphs; index as i"><a class="theme-link left-border theme-border" routerLink="." fragment="item{{i}}">{{para.heading}}</a></li>
        </ol>

        <section
          *ngFor="let para of result.paragraphs; index as i"
          class="grey-box"
          (click)="handleClick($event)">
          <a id="item{{i}}"></a>
          <h2>{{i+1}}. {{para.heading}}</h2>
          <div [innerHTML]="para.data" class="app-prose-scope"></div>

          <aa-exit-button *ngIf="showExitBtn"></aa-exit-button>

        </section>
      </div>


      <!-- Get More Advice -->
      <a routerLink="/questions" role="button" draggable="false"  class="noprint govuk-button govuk-button--start govuk-!-margin-top-2 govuk-!-margin-right-6 theme-button">
        Get more advice
      </a>

      <!-- Contact us -->
      <ng-container *ngIf="!meta.hideContactBtn">
        <a [href]="meta.contactLink" role="button" draggable="false" class="noprint govuk-button govuk-button--start govuk-!-margin-top-2 theme-button"
           *ngIf="meta.contactLink; else defaultContact">
          Contact us
        </a>

        <ng-template #defaultContact>
          <a routerLink="/contact" role="button" draggable="false"  class="noprint govuk-button govuk-button--start govuk-!-margin-top-2 theme-button">
            Contact us
          </a>
        </ng-template>
      </ng-container>

      <!-- Print version -->
      <div *ngFor="let para of result.paragraphs" class="printonly" aria-hidden="true">

        <!-- add 'long' class to snippets over 1000 chars long, this is used to disable page-break-inside=avoid -->
        <div class="govuk-details" [ngClass]="{'long-snippet': para.data.length > 1000}">
          <div class="govuk-details__summary theme-color-before theme-link">
            <span class="govuk-details__summary-text">
              {{para.heading}}
            </span>
          </div>

          <div class="govuk-details__text" [innerHTML]="para.data"></div>
        </div>
      </div>

    </ng-container>

    <ng-template #noResult>
      <div class="govuk-error-message">
        Sorry! We can't find the advice you are looking for.
      </div>
    </ng-template>
  </div>

  <div class="govuk-grid-column-one-third noprint" *ngIf="result">

    <div class="theme-border side-panel">

      <!-- Advertising -->
      <aside *ngIf="meta.treeType == TreeType.AdvisorFreemium" class="related-items govuk-!-margin-bottom-5" role="complementary" >
        <aa-ad-banner></aa-ad-banner>
      </aside>

      <!-- Related Items -->
      <aside class="related-items govuk-!-margin-bottom-5" role="complementary" *ngIf="result.relatedAdvice.length > 0">
        <h2 class="govuk-heading-m" id="related-items-title">
          Related Advice
        </h2>

        <nav role="navigation" aria-labelledby="related-items-title">
          <ul class="govuk-list govuk-!-font-size-16">
            <li *ngFor="let item of result.relatedAdvice">

              <ng-container *ngIf="item.href; else invalidLink">

                <!-- external links -->
                <a class="theme-link left-border theme-border" [href]="item.href" target="_blank" *ngIf="item.isExternal; else internalLink">
                  {{item.text}}
                </a>

                <!-- internal links -->
                <ng-template #internalLink>
                  <a class="theme-link left-border theme-border" [routerLink]="item.href">
                  {{item.text}}
                  </a>
                </ng-template>
              </ng-container>

              <!-- invalid links -->
              <ng-template #invalidLink>
                <a>{{item.text}}</a>
              </ng-template>
            </li>
          </ul>
        </nav>
      </aside>

      <!-- Print and Share -->
      <aside class="related-items" role="complementary" >
        <h2 class="govuk-heading-m mobile-break" id="print-and-share-title">
          Print and Share
        </h2>

        <nav role="navigation" aria-labelledby="print-and-share-title">
          <ul class="govuk-list govuk-!-font-size-16">
            <li>
              <a class="theme-link" (click)="navigation.print()" href="#">
                <i class="theme-icon fa fa-print" aria-hidden="true"></i> Print a copy of this advice
              </a>
            </li>

            <li>
              <a class="theme-link" (click)="downloadPdf()" href="#">
                <i class="theme-icon fa fa-download" aria-hidden="true"></i>
                <ng-container *ngIf="downloadActive; else notActive">Download in progress...</ng-container>
                <ng-template #notActive>Download a copy as a PDF</ng-template>
              </a>

              <span class="govuk-error-message govuk-!-margin-top-2" *ngIf="downloadError">
                Sorry! The PDF download failed
              </span>
            </li>

            <!-- Share (Mobile or Safari) -->
            <li *ngIf="canShare">
              <a class="theme-link" (click)="share()" href="#" >
                <i class="theme-icon fa fa-share-alt" aria-hidden="true"></i> Send this advice to yourself or a friend
              </a>
            </li>

            <!-- Other desktop browsers -->
            <li *ngIf="!canShare">
              <a class="theme-link" (click)="toggleEmailForm()" href="#" >
                <i class="theme-icon fa fa-share-alt" aria-hidden="true"></i> Send this advice to yourself or a friend
              </a>

              <div class="govuk-inset-text" *ngIf="showEmailForm">
                <aa-email-advice [adviceDoc]="result"></aa-email-advice>
              </div>
            </li>

          </ul>
        </nav>
      </aside>
    </div>
  </div>
</div>

